import api from "@/store/api";
import { transformZoomUrlResponse } from "@/utils/schedule.util";

enum ZoomMeetingType {
  AppointmentEvent = "appointmentEvent",
  GroupClassEvent = "groupClassEvent",
}

type ZoomUrlRequest = {
  externalId: string;
  // when the group-class redesign flag is on, group-class joins use the v2
  // group-section-event start endpoint; callers pass the flag since RTK query builders
  // can't read feature flags directly
  isGroupClassRedesignEnabled?: boolean;
  type: ZoomMeetingType;
};

const zoomApi = api.injectEndpoints({
  endpoints: (build) => ({
    getZoomUrl: build.query<ZoomUrlResponse, ZoomUrlRequest>({
      query: ({ externalId, isGroupClassRedesignEnabled, type }) => {
        if (type === ZoomMeetingType.AppointmentEvent) {
          return {
            body: { appointmentExternalId: externalId },
            method: "POST",
            url: "/schedule/family/meeting",
          };
        }
        // redesign on: the v2 group-section-event start endpoint; off: the legacy one
        const groupClassStartUrl = isGroupClassRedesignEnabled
          ? `/schedule/family/v2/group-section-event/${externalId}/start`
          : `/schedule/family/group-class-events/${externalId}/start`;
        return {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          url: groupClassStartUrl,
        };
      },
      // eslint-disable-next-line max-params
      transformResponse: (
        response,
        _,
        { isGroupClassRedesignEnabled, type },
      ) => {
        const isGroupClass = type === ZoomMeetingType.GroupClassEvent;
        if (isGroupClass) {
          return transformZoomUrlResponse({
            isGroupClass,
            isGroupClassRedesignEnabled,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- legitimate use case
            response: response as
              | GroupClassZoomUrlApiResponse
              | GroupSectionEventZoomUrlApiResponse,
          });
        }
        return transformZoomUrlResponse({
          isGroupClass: false,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- legitimate use case
          response: response as AppointmentZoomUrlApiResponse,
        });
      },
    }),
  }),
});

const { useLazyGetZoomUrlQuery } = zoomApi;

export { useLazyGetZoomUrlQuery, ZoomMeetingType };
